import type { JSX, ReactNode } from 'react';
import React from 'react';

import PrimaryNav from './Page/PrimaryNav';

import * as styles from './AppLayout.css';

interface IAppLayoutProps {
  children: ReactNode;
}

function AppLayout({ children }: Readonly<IAppLayoutProps>): JSX.Element {
  return (
    <div className={styles.root}>
      {children}
      <PrimaryNav className={styles.sidebar} />
    </div>
  );
}

export default AppLayout;
